<wiz-hgroup width="100%" height="100%" gap="10" class="section-container-parent"> <!--c'est une sous-vue-->
  <!-- l'arbre des chronocodes -->
  <wiz-vgroup width="350px" height="100%" padding="5px" class="section-container">
    <!--  bouton d'action -->
    <wiz-hgroup width="100%" horizontalAlign="end" verticalAlign="end">
      <wiz-button
      #btOk
      [wizIcon]="'arrow-right'"
      [iconPlacement]="'right'"
      [wizLabel]="'$.common.save.modification.$'"
    ></wiz-button>
      <wiz-button
        #btCancel
        class="cancel-button"
        [wizIcon]="'arrow-left'"
        [wizLabel]="'$.common.cancel.modification.$'"
      ></wiz-button>
    </wiz-hgroup>
    <wiz-tree #vgTreeContainer
    width="100%"
    height="100%"
    [wizDataProvider]="chronocodeDS"
    itemHeight="30"
    [actionsRenderer]="actionTreeRenderer"></wiz-tree>
    <filter-component #vgTreeContainerFilter  minHeight="44px" width="100%"></filter-component>
  </wiz-vgroup>

  <!-- zone détail -->
  <wiz-vgroup width="300px" [visible]="hasSelected" [height]="'100%'" padding="10px" class="section-container" gap="20">
    <!-- <wiz-label [wizLabel]="'$.common.detail.title.$'" class="titleLabel"></wiz-label> -->

    <!-- informations non éditable -->
    <wiz-vgroup width="100%">
      <wiz-hgroup width="100%" gap="0">
        <wiz-label width="100px" [wizLabel]="'$.chronocode.parent_code.$'"></wiz-label>
        <wiz-label #lblParentCode width="180px" [wizTextBehavior]="'truncate'"></wiz-label>
      </wiz-hgroup>
      <!-- <wiz-text-input #tiShortCode wizValidator [wizLabel]="'$.chronocode.shortcode.$'" [wizMandatory]=true
            [wizPlaceholder]="'$.common.define.$'"></wiz-text-input> -->
      <wiz-hgroup width="100%" gap="0">
        <wiz-label width="100px" [wizLabel]="'$.common.code.$'"></wiz-label>
        <wiz-label #lblCode width="180px" [wizTextBehavior]="'truncate'"></wiz-label>
      </wiz-hgroup>
      <wiz-hgroup width="100%" gap="0">
        <wiz-label width="100px" [wizLabel]="'$.chronocode.shortcode.$'"></wiz-label>
        <wiz-label #lblShortCode width="180px" [wizTextBehavior]="'truncate'"></wiz-label>
      </wiz-hgroup>
      <!-- <wiz-text-input #tiCode wizValidator [wizLabel]="'$.common.code.$'" [wizMandatory]=true
            [wizPlaceholder]="'$.common.define.$'"></wiz-text-input> -->
    </wiz-vgroup>

    <!--  champs d'édition -->
    <wiz-vgroup #vgDetailZone wizValidationContainer>
      <wiz-translation
        #tiLabelTrs
        [width]="'250px'"
        wizValidator
        [wizLabel]="'$.common.label.$'"
        [wizMandatory]="true"
        [wizPlaceholder]="'$.common.define.$'"
        [wizMaxChars]="100"
        [wizShowErrors]="true"
      ></wiz-translation>

      <wiz-vgroup width="130px">
        <wiz-label wizLabel="$.style.css.backgroundcolor.$" style="font-size: 11px"></wiz-label>
        <wiz-hgroup verticalAlign="center">
          <span
            #blockBack
            [style.backgroundColor]="backgroundColor"
            width="20px"
            height="20px"
            (click)="showColorPicker($event)"
            style="cursor: pointer; border-radius: 20px; border-style: solid; border-width: 1px"
          ></span>
          <wiz-icon style="cursor: pointer; font-size: 20px" (click)="resetColor('blockBack')">removal</wiz-icon>
        </wiz-hgroup>
      </wiz-vgroup>

      <!-- <wiz-translation #tiLevelLabelTrs [width]="'300px'" [wizLabel]="'$.chronocode.level.$'" [wizMandatory]=true
            [wizPlaceholder]="'$.common.define.$'" [wizMaxChars]=100 [wizShowErrors]=true></wiz-translation> -->
      <wiz-hgroup gap="20">
        <wiz-datefield
          #dfStartDate
          wizValidator
          [wizMandatory]="true"
          [wizLabel]="'$.chronocode.start.date.$'"
          [wizPlaceholder]="'$.common.define.$'"
          [wizDisabled]="true"
        ></wiz-datefield>
        <wiz-datefield
          #dfEndDate
          wizValidator
          [wizMandatory]="true"
          [wizLabel]="'$.chronocode.end.date.$'"
          [wizPlaceholder]="'$.common.define.$'"
          [wizDisabled]="true"
        ></wiz-datefield>
      </wiz-hgroup>
    </wiz-vgroup>

    <!-- informations complémentaires -->
    <wiz-vgroup width="100%">
      <wiz-hgroup width="100%">
        <wiz-label width="100%" [wizLabel]="'$.chronocode.nbdays.$'"></wiz-label>
        <wiz-label width="50px" #lblNbDays></wiz-label>
      </wiz-hgroup>
      <wiz-hgroup width="100%">
        <wiz-label width="100%" [wizLabel]="'$.chronocode.nbsaturdays.$'"></wiz-label>
        <wiz-label width="50px" #lblNbSaturdays></wiz-label>
      </wiz-hgroup>
      <wiz-hgroup width="100%">
        <wiz-label width="100%" [wizLabel]="'$.chronocode.nbsundays.$'"></wiz-label>
        <wiz-label width="50px" #lblNbSundays></wiz-label>
      </wiz-hgroup>
    </wiz-vgroup>
    <wiz-spacer height="100%"></wiz-spacer>
  </wiz-vgroup>

  <!-- zone de gestion des libellés de niveaux -->
  <wiz-vgroup width="220px" padding="5px" height="100%" class="section-container">
    <wiz-hgroup verticalAlign="center">
      <wiz-label class="titleLabel" [wizLabel]="'$.freedata.values.levels.$'"></wiz-label>
    </wiz-hgroup>
    <wiz-vgroup wizValidationContainer width="100%" height="100%" style="overflow: auto"
      ><ng-container #containerLevels></ng-container>
    </wiz-vgroup>
  </wiz-vgroup>
</wiz-hgroup>
